/**
 * @generated SignedSource<<8e9fade53ba63fc31399336f77f21aea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateViewerNotificationSettingsInput = {
  projectStatusEmailEnabled?: boolean | null;
  projectStatusEmailDay?: string | null;
  projectStatusEmailHour?: number | null;
  projectDeadlineOnlyAssignedProjects?: boolean | null;
  stateChangedOnlyAssignedProjects?: boolean | null;
  invoiceDueDateOnlyOwned?: boolean | null;
  invoiceOverdueOnlyOwned?: boolean | null;
  invoiceDaysOverdueOnlyOwned?: boolean | null;
  invoiceCreatedOrDeletedOnlyOwned?: boolean | null;
  invoiceStatusChangeOnlyOwned?: boolean | null;
  invoiceDateReachedOnlyOwned?: boolean | null;
  invoicePaymentOnlyOwned?: boolean | null;
  invoiceDateChangedOnlyOwned?: boolean | null;
  invoiceDueDateChangedOnlyOwned?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateViewerNotificationSettingsMutation$variables = {
  input: UpdateViewerNotificationSettingsInput;
};
export type UpdateViewerNotificationSettingsMutation$data = {
  readonly updateViewerNotificationSettings: {
    readonly personNotificationSettings: {
      readonly id: string;
      readonly projectStatusEmailEnabled: boolean | null;
      readonly projectStatusEmailDay: string | null;
      readonly projectStatusEmailHour: number | null;
      readonly projectDeadlineOnlyAssignedProjects: boolean | null;
      readonly stateChangedOnlyAssignedProjects: boolean | null;
      readonly invoiceDueDateOnlyOwned: boolean | null;
      readonly invoiceOverdueOnlyOwned: boolean | null;
      readonly invoiceDaysOverdueOnlyOwned: boolean | null;
      readonly invoiceCreatedOrDeletedOnlyOwned: boolean | null;
      readonly invoiceStatusChangeOnlyOwned: boolean | null;
      readonly invoiceDateReachedOnlyOwned: boolean | null;
      readonly invoicePaymentOnlyOwned: boolean | null;
      readonly invoiceDateChangedOnlyOwned: boolean | null;
      readonly invoiceDueDateChangedOnlyOwned: boolean | null;
    } | null;
  } | null;
};
export type UpdateViewerNotificationSettingsMutation = {
  variables: UpdateViewerNotificationSettingsMutation$variables;
  response: UpdateViewerNotificationSettingsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateViewerNotificationSettingsPayload",
    "kind": "LinkedField",
    "name": "updateViewerNotificationSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PersonNotificationSettingsType",
        "kind": "LinkedField",
        "name": "personNotificationSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectStatusEmailEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectStatusEmailDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectStatusEmailHour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectDeadlineOnlyAssignedProjects",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stateChangedOnlyAssignedProjects",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDueDateOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceOverdueOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDaysOverdueOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceCreatedOrDeletedOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceStatusChangeOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDateReachedOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoicePaymentOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDateChangedOnlyOwned",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDueDateChangedOnlyOwned",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateViewerNotificationSettingsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateViewerNotificationSettingsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cb0de041ee34f18e12dd973bbd888211",
    "id": null,
    "metadata": {},
    "name": "UpdateViewerNotificationSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateViewerNotificationSettingsMutation(\n  $input: UpdateViewerNotificationSettingsInput!\n) {\n  updateViewerNotificationSettings(input: $input) {\n    personNotificationSettings {\n      id\n      projectStatusEmailEnabled\n      projectStatusEmailDay\n      projectStatusEmailHour\n      projectDeadlineOnlyAssignedProjects\n      stateChangedOnlyAssignedProjects\n      invoiceDueDateOnlyOwned\n      invoiceOverdueOnlyOwned\n      invoiceDaysOverdueOnlyOwned\n      invoiceCreatedOrDeletedOnlyOwned\n      invoiceStatusChangeOnlyOwned\n      invoiceDateReachedOnlyOwned\n      invoicePaymentOnlyOwned\n      invoiceDateChangedOnlyOwned\n      invoiceDueDateChangedOnlyOwned\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a9f1f5ff0f7f7a1ad1e7e512d3216ab";

export default node;
